import { render, staticRenderFns } from "./LeadCategories.vue?vue&type=template&id=5d4dd130&scoped=true"
import script from "./LeadCategories.vue?vue&type=script&lang=ts"
export * from "./LeadCategories.vue?vue&type=script&lang=ts"
import style0 from "./LeadCategories.vue?vue&type=style&index=0&id=5d4dd130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4dd130",
  null
  
)

export default component.exports